import {
  MDBAlert,
  MDBBtn,
  MDBBtnGroup,
  MDBCheckbox,
  MDBChip,
  MDBDatatable,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { addRemoveUsersFromGroup, deleteUserInfo, exportUsersInfo, getAssociatedCFData, getGlobalLocationList, getLoginToStreams, getMisc, setGlobalLocationFilter } from "../../apiclients/streamsapi_bridge";
import defaultUImg from "../../components/images/default-user-img.svg";
import PopupLoader from "../../views/popups/PopupLoader";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import AddToUsers from "../../views/popups/misc/AddToUsers";
import RemoveToUser from "../../views/popups/misc/RemoveToUser";
import AddWIEvents from "../../views/popups/users/AddWIEvents";
import DeleteUser from "../../views/popups/users/DeleteUser";
import DeleteUserFilter from "../../views/popups/users/DeleteUserFilter";
import AddtoUserGroup from "../../views/popups/users/MultiSelect/AddtoUserGroup";
import ChangeBillingGroup from "../../views/popups/users/MultiSelect/BillingGroup";
import ChangeCallerId from "../../views/popups/users/MultiSelect/CallerId";
import CallingPermissions from "../../views/popups/users/MultiSelect/CallingPermissions";
import ChangeLocation from "../../views/popups/users/MultiSelect/ChangeLocation";
import ChangePermissionRole from "../../views/popups/users/MultiSelect/ChangePermissionRole";
import ChangeSeatPlan from "../../views/popups/users/MultiSelect/ChangeSeatPlan";
import EnableAddOn from "../../views/popups/users/MultiSelect/EnableAddOn";
import ResendWelcomeEmail from "../../views/popups/users/MultiSelect/ResendWelcomeEmail";
import ResetPassword from "../../views/popups/users/MultiSelect/ResetPassword";
import AddUser from "../../views/popups/users/addUsers";
import ExportUsers from "../editviews/user/ExportUsers";
import ImportUser from "../editviews/user/ImportUser";
import UIConstant from "../../apiclients/UIConstant";
import { show_links_tab, call_routing_service_id } from "../../apiclients/apiurls";
import { isFiveNineAccount } from "../../views/Login";
import { getImpExpStatusNew, getStreamsProductName } from "../../apiclients/CommonUtils";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import CommonMoreOptions from "../../apiclients/CommonMoreOptions";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";


export default function Users(props) {
  /************************************************************************/
  const [users, setUsers] = useState([]);
  // const [userList, setUserList] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [terms, setTerms] = useState([]);
  const [adduser, setAdduser] = useState(
    props.addUsers ? props.addUsers : false
  );
  const [adduserToGroup, setAdduserToGroup] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const [ExportUser, setExportUser] = useState(false);
  const [deleteuser, setDeleteuser] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [isloading, setIsloading] = useState(true);
  const [extension, setExtension] = useState("")
  const togglegPopup = () => setAdduserToGroup(!adduserToGroup);
  const togglePopup = () => setAdduser(!adduser);
  const dtogglePopup = () => setDeleteuser(!deleteuser);
  const importuserToggle = () => setimportUser(!importUser);
  const ExportUserToggle = () => setExportUser(!ExportUser);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasPrevilege, setHasPrevilege] = useState(false);
  const [position, setPosition] = useState('top-center');
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [groupUsers, setGroupUsers] = useState([]);
  const [isdeleteUser, setIsDeleteUser] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const dUtogglePopup = () => setIsDelete(!isdelete);

  const streamsProductName = getStreamsProductName();

  // toggle popup for multi select

  const [agentList, setagentList] = useState([]);
  const [agentNameList, setagentNameList] = useState([]);
  const [selectedSeats, setselectedSeats] = useState("");
  const [selectedRoles, setselectedRoles] = useState("");
  const [selectedSeatIds, setselectedSeatIds] = useState([]);
  const [selectedRoleIds, setselectedRoleIds] = useState([]);
  const [roleFiltersList, setroleFiltersList] = useState([]);
  const [seatFIlterList, setseatFIlterList] = useState([]);
  const [existSelectedSeats, setexistSelectedSeats] = useState([]);
  const [existSelectedRoles, setexistSelectedRoles] = useState([]);
  const [newSeletcedList, setnewSeletcedList] = useState([]);
  const [reRender, setreRender] = useState(true);
  const [deleteFilter, setdeleteFilter] = useState(false);
  const deleteFilterToggle = () => setdeleteFilter(!deleteFilter);
  const [filterKey, setfilterKey] = useState(0);
  const [disableMulti, setdisableMulti] = useState(true);
  const addUserRef = useRef(null);
  const addToUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [storageAgents, setStorageAgents] = useState([]);
  const [deleteReasons, setdeleteReasons] = useState([]);
  const [transferMessage, settransferMessage] = useState("");
  const [streamletAlertInfo, setstreamletAlertInfo] = useState([]);
  const [searchValue, setsearchValue] = useState("");
  const [proccessdRows, setProccessdRows] = useState([]); // Store the processed rows
  const [filteredRows, setFilteredRows] = useState([]);
  const [allChecked, setallChecked] = useState(false);
  const [assocCallFlows, setAssocCallFlows] = useState([]);
  const [assocLunaHops, setassocLunaHops] = useState([]);
  const [disableExport, setdisableExport] = useState(false);
  const [firstRequest, setfirstRequest] = useState(false);
  const [isFiveNineAcc, setisFiveNineAcc] = useState(false);
  const isFiveNineAccounts = isFiveNineAccount();
  const [showWarning, setShowWarning] = useState(false);
  const warningToggle = () => setShowWarning(!showWarning);
  const [warningMessage, setWarningMessage] = useState("");
  const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
  const ppLogin = JSON.parse(sessionStorage.getItem("admin_session"))?.loggedInFromPP ?? false
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  const [DropDownitem, setDropDownitem] = useState([
    {
      label: "Caller-ID",
      // onClick: toggleCallerid,
      key: "caller-id",
      show: !isFiveNineAccounts,
    },
    // {
    //   label: "Change Calling Permissions",
    //   onClick: toggleChangeCallingPermissions,
    //   key: "calling-permissions",
    //   show: !isFiveNineAccounts,
    // },
    {
      label: "Change Location",
      // onClick: toggleLocation,
      key: "location",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Billing Group",
      // onClick: toggleBillingGroup,
      key: "billing-group",
      show: !isFiveNineAccounts,
    },
    // {
    //   label: "Enable/Disable an Add-On",
    //   onClick: toggleAddons,
    //   key: "addons",
    //   show: !isFiveNineAccounts,
    // },
    {
      label: "Change Seat Plan",
      // onClick: toggleSeatsPlans,
      key: "seat-plan",
      show: !isFiveNineAccounts,
    },
    {
      label: "Change Permission Role",
      // onClick: togglePermissionRole,
      key: "permission-role",
      show: !isFiveNineAccounts,
    },
    // {
    //   label: "Configure Web Integration",
    //   onClick: toggleWebIntegration,
    //   key: "web-integration",
    //   show: !isFiveNineAccounts,
    // },
    {
      label: "Add to a Group",
      // onClick: toggleAddGroup,
      key: "add-group",
      show: !isFiveNineAccounts,
    },
    // {
    //   label: "Reset Password",
    //   onClick: toggleResetPasswords,
    //   key: "reset-password",
    //   show: !isFiveNineAccounts,
    // },
    {
      label: "Resend Welcome Email",
      // onClick: toggleResendEmails,
      key: "resend-email",
    },
    // {
    //   label: "Delete",
    //   onClick: handleMultiDelete,
    //   key: "delete",
    //   show: !isFiveNineAccounts,
    //   className: "text-danger",
    // },
  ]);


  /*************************************************************************/
  useEffect(() => {
    if (hasPrevilege) {
      setTimeout(() => {
        setHasPrevilege(false)
        setErrorMessage("");
      }, 5000);
    }
  }, [hasPrevilege]);

  function handleClick() {
    addUserRef.current.click();
  }
  function handleAddToUser() {
    addToUserRef.current.click();
  }

  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
  function showThisInf(e) {
    console.log(e.userInfo);
    let selMember = e.userInfo;
    const currentIndex = users.findIndex((tmdata) => tmdata.email == selMember.email);
    const previousUser = currentIndex > 0 ? users[currentIndex - 1] : null;
    const nextUser = currentIndex < users.length - 1 ? users[currentIndex + 1] : null;
    const combinedData = {
      selMember,
      previousUser,
      nextUser,
      users
    };

    navigate("/useredit", {
      state: combinedData,
    });
  }
  async function deletethisUSer(evntData, agentId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      let associatedCF = await getAssocCFDataByEntityIdNodeType(JSON.parse(sessionStorage.getItem("admin_session")).siteid, agentId, 6);
      setAssocCallFlows(associatedCF?.associated_callflows ?? []);
      setassocLunaHops(associatedCF?.associated_luna_hops ?? []);

      console.log("event data:: ");
      console.log(evntData);
      let selMember = users.filter((tmdata) => tmdata.agentid == agentId)[0];
      console.log("selMember :::::::::::::: " + JSON.stringify(selMember));
      setagentNameList([selMember.fname + " " + selMember.lname]);
      fetchDeleteUserInfo([selMember.agentid]);
      setSelectedUser([selMember.agentid]);
      setExtension(selMember.extension)
    } else if (result.isOwnUser) {
      setShowImpExpRedirect(true);
    } else {
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      warningToggle();
    }
  }

  function handleMultiDelete() {

    fetchDeleteUserInfo(agentList);
    setSelectedUser(agentList);

  }

  async function fetchDeleteUserInfo(agentids) {
    console.log("agentid ::::::::::::::::; ", agentids);
    setIsloading(true);
    let update = {
      reqid: 4,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentids: agentids,
    }

    console.log("fetch for delete request :::::" + JSON.stringify(update));
    const response = await deleteUserInfo(update);

    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    console.log("rawdata in user ::::", JSON.stringify(rawData))
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + JSON.stringify(rawData));
    setStorageAgents(rawData?.transfer_agent !== undefined ? rawData?.transfer_agent : null);
    setdeleteReasons(rawData?.delete_reasons ?? []);
    settransferMessage((!rawData?.delete_reasons || rawData?.delete_reasons.length === 0) && rawData?.storage_msg ? rawData.storage_msg : "");
    setstreamletAlertInfo(rawData?.streamlet_alert_list ?? []);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    setDeleteuser(true);

  }
  function loadDefault(tObj) {
    tObj.target.src = defaultUImg;
  }
  async function openStreams(e, agentid) {
    e.preventDefault();
    e.stopPropagation();
    const response = await getLoginToStreams(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid
    );

    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }

    const responseData = await response.json();
    const streamsURL = responseData.streamsUrl;
    window.open(streamsURL, "_new");
  }

  useEffect(() => {
    if (props.userList && props.userList.length > 0) {
      fetchSData();      
      // setUserList(props.userList);
    } else {
      setIsloading(false);
    }

  }, [props.userList]);

  async function fetchSData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["services", "term"] }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    setUsers(props.userList)
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(tdata);
    setServices(tdata.misc.services);
    setTerms(tdata.misc.term);
    // setTimeout(() => {
      setIsloading(false);
    // }, 1000);
  }

  useEffect(() => {
    let proccessdRows = [];
    users.map((user) => {
      const roles = user?.role ?? [];
      const rolesToString = Array.isArray(roles) ? roles.join(', ') : '';
      proccessdRows.push({
        userInfo: user,
        agentid: user.agentid,
        checkBox: (
          <MDBCheckbox checked={agentList.includes(user.agentid)} onClick={(e) => handleCheckedRow(e, user)} />
        ),
        userimage: (
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={user?.profile_pic_link ?? defaultUImg}
              onError={(e) => loadDefault(e)}
              alt=""
              style={{
                width: "45px",
                height: "45px",
              }}
              className="rounded-circle"
            />
          </div>
        ),
        username: user.fname && user.lname ? `${user.fname} ${user.lname}` : user.name,
        extension: user.extension ? user.extension : "--",
        email: user.email,
        emailverified: user.email_verified === "yes" ? (
          <MDBIcon fas icon="check" color='success' className='fw-bold ps-3 ms-4' />
        ) : (
          <h6 className="no-red fw-bold ps-3 ms-4">No</h6>
        ),
        service: services?.filter((item) => item.id === user.serviceid).length > 0
          ? services?.filter((item) => item.id === user.serviceid)[0].name
          : user.serviceid === call_routing_service_id
            ? "Call Routing"
            : user.seat_plan || "",
        location_name: user.location_name,
        roles: rolesToString || user.role_name || "--",
        streams_login: user.streams_login ? (
          <div className="d-flex align-items-center ms-2">
            <div className="custom-hover-bg p-1 cursor-pointer streamsLogin" onClick={(e) => openStreams(e, `${user.agentid}`)}>
              <MDBIcon fas icon="sign-in-alt" color="primary" className="mx-2 my-1 fs-5" />
            </div>
          </div>
        ) : "",
        ...((!isDisabled && !isFiveNineAcc) && {
          remove: (
            <div className="d-flex align-items-center justify-content-center">
              <div
                className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (props.groupUInfo) {
                    handleDelete(e, user);
                  } else {
                    deletethisUSer(e, `${user.agentid}`);
                  }
                }}
              >
                <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
              </div>
            </div>
          )
        })
        ,
      });
    });

    // Sort rows if necessary (e.g., by username)
    proccessdRows = proccessdRows.sort(compareUsername);

    // Set the processed rows as initial rows
    setProccessdRows(proccessdRows);
    setFilteredRows(proccessdRows); // Initialize filtered rows with all rows
    setDataLoaded(true)
  }, [users,props.isActive]);

  useEffect(() => {
    setFilteredRows(filteredRows.map(user => ({
      ...user, checkBox: (
        <MDBCheckbox checked={agentList.includes(user.agentid)} onClick={(e) => handleCheckedRow(e, user)} />
      )
    })))
  }, [agentList]);

  function compareUsername(a, b) {
    const usernameA = a.username.toLowerCase() || "";
    const usernameB = b.username.toLowerCase() || "";

    if (usernameA < usernameB) return -1;
    if (usernameA > usernameB) return 1;
    return 0;
  }
  const handleAllChecked = (isChecked) => {
    if (isChecked) {
      setallChecked(true);
      const agentIds = [];
      const agentNames = [];
      filteredRows.forEach(({ agentid, username }) => {
        agentIds.push(agentid);
        agentNames.push(username);
      });
      setagentList(agentIds);
      setagentNameList(agentNames);
      setdisableMulti(false);


    } else {
      setallChecked(false);
      setagentList([]);
      setagentNameList([]);
      setdisableMulti(true);
    }
  }

  const basicData = {
    columns: [
      {
        label: (<>
          <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
        </>), field: "checkBox", sort: false
      },
      { label: "", field: "userimage", sort: false, colSpan: 2 },
      {
        label: "User",
        field: "username",
        sort: true,
        colSpan: 1,
      },
      { label: "Extension", field: "extension" },
      { label: "Email", field: "email" },
      { label: "Email Verified", field: "emailverified", sort: false },
      { label: "Seat Plan", field: "service" },
      { label: "Location", field: "location_name" },
      { label: "Role", field: "roles" },
      (ppLogin) && { label: `${streamsProductName} Login`, field: "streams_login", sort: false },
      (!isDisabled && !isFiveNineAcc) && { label: "Remove", field: "remove", sort: false },
    ].filter(Boolean),
    rows: filteredRows,
  };



  useEffect(() => {
    setisFiveNineAcc(isFiveNineAccount());
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.usersData-Table');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);



  console.log("proccessdRows ::::::::::::::::::::: " + proccessdRows.length)
  useEffect(() => {
    const disabledState = () => {
      const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
      const isAdmin = isAdminSession?.permissions ? !isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_USER) ||
        !isAdminSession?.permissions.includes(UIConstant.ALLOW_MANAGED_SEAT)
        : false;
      setIsDisabled(isAdmin);
    };
    disabledState();
  }, []);

  const handleDelete = async (event, infoObj) => {
    event.preventDefault();
    const result = await getImpExpStatusNew();
    if (result.status === 0) {
      dUtogglePopup();
      setUpdateUsers([infoObj]);
    } else if (result.isOwnUser) {
      setShowImpExpRedirect(true);
    } else {
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      warningToggle();
    }
  };


  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      updateTheUser("add_users");
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  useEffect(() => {
    if (updateUsers.length > 0 && isdeleteUser) {
      updateTheUser("remove_users");
      setIsDeleteUser(false);
    }
  }, [updateUsers, isdeleteUser]);

  async function updateTheUser(fieldName) {
    const agentids = new Set(updateUsers.map(item => item.agentid));
    let update = {}


    let saverep;

    update = {
      reqid: 77,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      usergroup_id: props.groupUInfo.usergroup_id,
      [fieldName]: Array.from(agentids),



    };
    // alert("Request ::::::::: "+JSON.stringify(update))
    console.log("Add Remove Users Request ::: " + JSON.stringify(update));
    saverep = await addRemoveUsersFromGroup(update);

    console.log(saverep);
    let saverepeMsg = await saverep.json();
    //  alert(JSON.stringify(saverepeMsg));
    // const usernames = new Set(updateUsers.map(item => item.name));
    // const users = Array.from(usernames).join(', ');
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
    } else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
    navigate("/SelectedUserGroupSettings", {
      state: { tab: "tab2", groupUInfo: props.groupUInfo },
    });
    window.location.reload();
  }

  function handleCheckedRow(e, selectrow) {
    // e.preventDefault();
    let agents = selectrow.agentid;
    let agentname = selectrow.fname + " " + selectrow.lname;
    let updatedAgents = [];
    let updatedAgentNames = [];

    if (e.target.checked) {
      updatedAgents = [...agentList, agents];
      updatedAgentNames = [...agentNameList, agentname];


    } else {
      updatedAgents = agentList.filter((tmdata) => tmdata !== agents);
      updatedAgentNames = agentNameList.filter((tmdata) => tmdata !== agentname);

    }

    const allSelected = filteredRows.length > 0 ? filteredRows.every(row => updatedAgents.includes(row.agentid)) : false;
    if (allSelected) {
      setallChecked(true);
    } else {
      setallChecked(false);
    }
    if (updatedAgents.length > 0) {
      setdisableMulti(false);
    } else {
      setdisableMulti(true);
    }
    setagentList(updatedAgents);
    setagentNameList(updatedAgentNames);
  }


  /********************************Fetching Display Data Starts Here!************************************************* */

  // useEffect(() => {
  //   fetchSData();
  // }, [props.userList]);
  /********************************************************************************* */

  const [addFilter, setAddFilter] = useState(false);
  const [showSeatPlan, setShowSeatPlan] = useState(false);
  const [showRole, setShowRole] = useState(false);

  const disableFilter = () => {
    setShowRole(false); // Ensure other div is hidden
    setShowSeatPlan(false); // Ensure other div is hidden
  }

  const toggleFilter = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setAddFilter(!addFilter)
    setShowRole(false); // Ensure other div is hidden
    setShowSeatPlan(false); // Ensure other div is hidden
  };
  const toggleSeatPlan = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setnewSeletcedList([]);
    setShowSeatPlan(!showSeatPlan);
    setShowRole(false); // Ensure other div is hidden
  };

  const toggleRole = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowRole(!showRole);
    setnewSeletcedList([]);
    setShowSeatPlan(false); // Ensure other div is hidden
  };

  const toggleBackClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowRole(false); // Ensure other div is hidden
    setShowSeatPlan(false); // Ensure other div is hidden
  }

  useEffect(() => {
    if (reRender) {
      getUsersFilter();
      setreRender(false);
    }

  }, [reRender]);

  async function getUsersFilter() {
    try {
      const adminSession = sessionStorage.getItem("admin_session");
      const siteid = JSON.parse(adminSession).siteid;
      let response;
      const extracondition = `?module_type=2`;
      response = await getGlobalLocationList(siteid, extracondition);
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      let rawData = await response.json();
      console.log("Global user filter ::::::::: " + JSON.stringify(rawData));
      if (!rawData) {
        window.alert(`info with id  not found`);
        // navigate("/");
      }
      const userSeatFilters = rawData?.result?.seat_plan ?? [];
      const userRoleFilter = rawData?.result?.role ?? [];
      setTheStateValues(userSeatFilters, userRoleFilter);

    } catch (error) {

    }

  }

  function setTheStateValues(userSeatFilters, userRoleFilter) {
    const seatSelected = userSeatFilters.filter(seat => seat.selected).map(seat => seat.entity_name).join(', ');
    const seatSelectedids = userSeatFilters.filter(seat => seat.selected).map(seat => seat.entity_id);
    const rolesSelected = userRoleFilter.filter(role => role.selected).map(role => role.entity_name).join(', ');
    const rolesSelectedids = userRoleFilter.filter(role => role.selected).map(role => role.entity_id);
    setroleFiltersList(userRoleFilter);
    setseatFIlterList(userSeatFilters);
    if (seatSelected && seatSelected !== "") {
      setselectedSeats(`${t("SeatPlan")} : ${seatSelected}`);
      setselectedSeatIds(seatSelectedids);
      setexistSelectedSeats(seatSelectedids);
    }
    if (rolesSelected && rolesSelected !== "") {
      setselectedRoles(`${t("Roles")} : ${rolesSelected}`);
      setselectedRoleIds(rolesSelectedids);
      setexistSelectedRoles(rolesSelectedids);
    }

  }

  const handleSeatCheckboxChange = (value) => {
    const updatedValues = [...selectedSeatIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    setselectedSeatIds(updatedValues);
  };

  const handleRoleCheckboxChange = (value) => {
    const updatedValues = [...selectedRoleIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    setselectedRoleIds(updatedValues);
  };
  const handleNewCheckboxChange = (value) => {
    const updatedValues = [...newSeletcedList];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    setnewSeletcedList(updatedValues);
  };

  function cancelSeatChanges(flag) {
    if (flag === 1) {
      setselectedSeatIds(existSelectedSeats);
    } else if (flag === 2) {
      setselectedRoleIds(existSelectedRoles);
    } else {
      setnewSeletcedList([]);
    }
  }

  const handleSubmit = async (event, filterKey, selectValue) => {
    event.preventDefault();
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: selectValue,
      filter_type: 1,
      filter_key: parseInt(filterKey),
      module_type: 2,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify location filter value  :::: " + JSON.stringify(update));
    // debugger;
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", saverepeMsg.message);
      // sessionStorage.removeItem('userSeatFilter');
      // sessionStorage.removeItem('userRoleFilter');

      if (props.locUsers) {
        navigate("/locationsusers", {
          state: { tab: props.locUsers },
        });

      } else if (props.groupInfo) {
        navigate("/usersgroups", {
          state: { tab: props.groupInfo },
        });

      }
      else if (props.groupUInfo) {
        navigate("/SelectedUserGroupSettings", {
          state: { tab: "tab2", groupUInfo: props.groupUInfo },
        });
      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }

      window.location.reload();
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  const handleDeleteSeatFilters = (value) => {
    removeThisFilter(1);

  }
  const handleDeleteRoleFilters = (value) => {
    removeThisFilter(2);
  }

  const removeallfilters = (value) => {
    removeThisFilter(-1);
  }
  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  async function removeThisFilter(filterKey) {
    // e.preventDefault();
    // console.log(props.filterKey);
    const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    setIsloading(true);
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: [-1],
      filter_type: 1,
      filter_key: filterKey ? parseInt(filterKey) : -1,
      module_type: 2,
    }
    console.log("Modify User filter value  :::: " + JSON.stringify(update));
    let deleteFilter = await setGlobalLocationFilter(update);;
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteFilter.json();
    console.log("Response... ");
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      props.onClose();
      window.location.href = "/userlanding";
    } else {
      localStorage.setItem("s_message", deleteMsg.message);
      // sessionStorage.removeItem('userSeatFilter');
      // sessionStorage.removeItem('userRoleFilter');
      if (props.locUser) {
        navigate("/locationsusers", {
          state: { tab: props.locUser },
        });

      } else if (props.groupInfo) {
        navigate("/usersgroups", {
          state: { tab: props.groupInfo },
        });

      } else if (props.groupUInfo) {
        navigate("/SelectedUserGroupSettings", {
          state: { tab: "tab2", groupUInfo: props.groupUInfo },
        });
      } else {
        navigate("/userlanding", {
          state: { tab: "suser", tab2: "suser" },
        });
      }

      window.location.reload();
    }
  }

  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);

    const filteredUsers = customSearch(proccessdRows, searchValue, UIConstant.USERDETAILS);

    setFilteredRows(filteredUsers);
  };



  const handleExportUsers = (e) => {
    e.preventDefault();
    setdisableExport(true);
    setIsloading(true);
    exportUsersData();
  }

  const exportUsersData = async () => {
    try {
      let apiResponse = await exportUsersInfo(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
      console.log("apiResponse ::::::::::::::: " + JSON.stringify(apiResponse));
      // debugger;

      let filename = "";
      if (apiResponse.status == 200) {
        const contentDisposition = apiResponse.headers.get("Content-Disposition");
        setdisableExport(false);
        setTimeout(() => {
          setIsloading(false);
        }, 1000);
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // setInternalError(true);
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  }

  const handleforImpExp = async (action) => {
    const result = await getImpExpStatusNew();

    if (result.status === 0) {
      // Case 0: no operation in progress — proceed normally
      if (action === "addUser") {
        togglePopup();
      } else if (action === "importUser") {
        setfirstRequest(true);
        importuserToggle();
      }
    } else if (result.isOwnUser) {
      // Case 1: own user initiated → redirect
      if (action === "importUser") {
        setfirstRequest(true);
        importuserToggle();
      } else {
        setShowImpExpRedirect(true);
      }
    } else {
      // Case 2: another user/account initiated → warning popup
      const { userInfo } = result;
      if (userInfo?.isaccount) {
        setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
      } else {
        setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
      }
      warningToggle();
    }
  }


  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div className="position-absolute left__341px d-flex align-items-center">
        <div className="d-flex">
          {selectedSeats && (
            <>
              <div className="mx-2 popconfirmFilter">
                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>

                  <MDBChip className="m-0" onClick={(e) => { e.preventDefault(); }} >
                    <div className="filterElliipse">
                      {selectedSeats}
                    </div>
                    <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDeleteSeatFilters() }} />
                  </MDBChip>

                </>}>

                  <MDBPopconfirmMessage>
                    <div className="fw-500">
                      Seat Plan
                    </div>
                    <div className="filter-border"></div>
                    <div className="ps-2 pb-2 filtersScroll">
                      {seatFIlterList && seatFIlterList.map((seat) => (
                        <div className="" key={seat.entity_id}>
                          <MDBCheckbox name='flexCheck' value={seat.entity_id} id={seat.entity_id} label={seat.entity_name} checked={selectedSeatIds.includes(seat.entity_id)}
                            onChange={() => handleSeatCheckboxChange(seat.entity_id)}
                          />
                        </div>
                      ))}

                      {(selectedSeatIds.length > 0 && !isArraysEqual(selectedSeatIds, existSelectedSeats)) && (
                        <>
                          <div className="filter-border"></div>
                          <div className="d-flex float-end mt-3">
                            <MDBBtn size="sm" color="secondary" onClick={(e) => cancelSeatChanges(1)}>Cancel</MDBBtn>
                            <MDBBtn size="sm" className="ms-2" onClick={(e) => {
                              handleSubmit(e, 1, selectedSeatIds);
                            }}>Apply</MDBBtn>
                          </div>
                        </>

                      )}
                    </div>
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>
              </div>
            </>
          )}
          {selectedRoles && (
            <div className="mx-3 popconfirmFilter">
              <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' rippleRadius={10} btnChildren={<>
                <MDBChip className="m-0" onClick={(e) => e.preventDefault()}>
                  <div className="filterElliipse">
                    {selectedRoles}
                  </div>
                  <MDBIcon fas icon="times" className="ms-2 fs-6" onClick={(e) => { e.stopPropagation(); handleDeleteRoleFilters() }} />
                </MDBChip>
              </>}>
                <MDBPopconfirmMessage>
                  <div className="fw-500">
                    Roles
                  </div>
                  <div className="filter-border"></div>
                  <div className="ps-2 pb-2 filtersScroll">
                    <div>
                      {roleFiltersList && roleFiltersList.map((role) => (
                        <div className="" key={role.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={role.entity_id} id={role.entity_id} label={role.entity_name} checked={selectedRoleIds.includes(role.entity_id)}
                            onChange={() => handleRoleCheckboxChange(role.entity_id)}
                          />
                        </div>
                      ))}

                    </div>
                  </div>
                  {(selectedRoleIds.length > 0 && !isArraysEqual(selectedRoleIds, existSelectedRoles)) && (
                    <>
                      <div className="filter-border"></div>
                      <div className="d-flex float-end mt-3">
                        <MDBBtn size="sm" onClick={(e) => {
                          handleSubmit(e, 2, selectedRoleIds);
                        }}> Apply</MDBBtn>

                        <MDBBtn size="sm" color="secondary" className="ms-2" onClick={(e) => cancelSeatChanges(2)}>Cancel</MDBBtn>
                      </div>
                    </>
                  )}
                </MDBPopconfirmMessage>
              </MDBPopconfirm>
            </div>
          )}
        </div>
        {/* <MDBBtn className="btn_adjust" onClick={toggleFilter}>
          <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}
        </MDBBtn> */}


        {!(selectedSeats && selectedRoles) && (
          <div className="">
            <MDBPopconfirm placement='bottom-start' onClick={disableFilter} btnChildren={(<>  <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}</>)}>
              <MDBPopconfirmMessage className="p-2">

                <div>
                  <p className='mb-3 fw-600 filterhead'>
                    {(showSeatPlan || showRole) ? (showSeatPlan ? "Seat Plan" : "Role") : "Filter by"}
                  </p>
                  {!showSeatPlan && !showRole && (
                    <>
                      <div className={"d-flex flex-column " + (selectedSeats !== "" ? "cursor-disabled" : "")}>
                        <div className={"cursor-pointer " + (selectedSeats !== "" ? "Filter_disabled" : "")} onClick={toggleSeatPlan}>
                          {/* <div className="d-flex flex-column ">
                      <div className="cursor-pointer" onClick={toggleSeatPlan}> */}
                          Seat Plan
                        </div>
                      </div>
                      <div className={"d-flex flex-column mt-2 " + (selectedRoles !== "" ? "cursor-disabled" : "")}>
                        <div className={"cursor-pointer mt-2 " + (selectedRoles !== "" ? "Filter_disabled" : "")} onClick={toggleRole}>
                          {/* <div className="d-flex flex-column mt-2">
                       <div className="cursor-pointer mt-2" onClick={toggleRole}> */}
                          Role
                        </div>
                      </div>
                    </>
                  )}

                  {showSeatPlan && (
                    <div className="filtersScroll">
                      {seatFIlterList && seatFIlterList.map((seat) => (
                        <div className="" key={seat.entity_id}>
                          <MDBCheckbox name='flexCheck' value={seat.entity_id} id={seat.entity_id} label={seat.entity_name} checked={newSeletcedList.includes(seat.entity_id)}
                            onChange={() => handleNewCheckboxChange(seat.entity_id)}
                          />
                        </div>
                      ))}
                    </div>
                  )}


                  {showRole && (
                    <div className="filtersScroll">
                      {roleFiltersList && roleFiltersList.map((role) => (
                        <div className="" key={role.entity_id}>
                          <MDBCheckbox name='flexCheck2' value={role.entity_id} id={role.entity_id} label={role.entity_name} checked={newSeletcedList.includes(role.entity_id)}
                            onChange={() => handleNewCheckboxChange(role.entity_id)}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {showSeatPlan || showRole ? (
                  <MDBModalFooter className="d-flex align-items-center justify-content-between pt-3">
                    <MDBBtn size='sm' outline color='secondary' onClick={toggleBackClick} className="mx-0">
                      Back
                    </MDBBtn>
                    {newSeletcedList.length > 0 && (
                      <div className="me-0">
                        <MDBBtn size='sm' color='secondary' className="me-2" onClick={(e) => cancelSeatChanges(3)}>
                          cancel
                        </MDBBtn>
                        <MDBBtn size='sm' onClick={(e) => {
                          if (showSeatPlan) {
                            handleSubmit(e, 1, newSeletcedList);
                          } else {
                            handleSubmit(e, 2, newSeletcedList);
                          }
                        }}>Apply</MDBBtn>
                      </div>
                    )}
                  </MDBModalFooter>
                ) : null}


              </MDBPopconfirmMessage>
            </MDBPopconfirm>

          </div>
        )}
        {(selectedSeats || selectedRoles) && (
          <MDBBtn className="mx-2" onClick={removeallfilters}>Clear</MDBBtn>
        )}
      </div>
      <div className="actionbar button_aligniment">
        <div className="float-end d-flex align-items-center mt-2_responsive">
            {!isFiveNineAcc && (
              <>
                {!isDisabled && (
                  <div className={`d-inline-block`}>
                    {props.groupUInfo ? (
                      <MDBBtn className="btn_adjust me-3" onClick={togglegPopup} >
                        <MDBIcon fas icon="plus" size="sm" className="me-2" /> {t("addusertogroup")}
                      </MDBBtn>
                    ) : (
                      <MDBBtn className="btn_adjust me-3" onClick={(e) => { e.preventDefault(); handleforImpExp("addUser"); }}>
                        <MDBIcon fas icon="plus" size="sm" className="me-2" /> {t("addusers")}
                      </MDBBtn>
                    )}
                  </div>
                )}

                {!isDisabled && (
                  <MDBBtn className=" me-3 btn_adjust" onClick={(e) => { e.preventDefault(); handleforImpExp("importUser"); }}>
                    <MDBIcon fas icon="upload" className="me-2" /> {t("importusers")}
                  </MDBBtn>
                )}

                {/* <MDBBtn className="btn_adjust" onClick={ExportUserToggle} > */}

                <MDBBtn className="btn_adjust" disabled={disableExport} onClick={(e) => handleExportUsers(e)} >
                  <MDBIcon fas icon="download" className="me-2" /> {t("exportusers")}
                </MDBBtn>
              </>
            )}

            {!isDisabled && (
              <CommonMoreOptions
                DropDownitem={DropDownitem}
                disableMulti = {disableMulti}
                agentList = {agentList}
                locUser = {props?.locUser}
                groupInfo={props?.groupInfo ?? null}
                groupUInfo={props?.groupUInfo ?? null}
                moduleType = {1}
                moduleid = "common-more-options-portal"
                showWarning = {true}
                onImpExpRedirect={() => setShowImpExpRedirect(true)}
                onImpExpWarning={(msg) => { setWarningMessage(msg); warningToggle(); }}
              />
            )}
          </div>
      </div>
      <div className='mb-2 mt-3 position-relative w-auto'>
      <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
      </div>
      <div className="w-100 usersDataTable actioncolumn">
        <MDBDatatable
         key={searchValue}
        //  key={searchValue.trim() ? 'search' : 'default'}
        // search
          fixedHeader
          entries={50}
          // maxHeight="55vh"
          multi
          // selectable 
          sortField="User"
          sortOrder="asc"
          searchInputProps={[]}
          data={{
            ...basicData,
            rows: filteredRows, // Use filtered rows here
          }}
          responsive
          hover
          className="usersData-Table"
          // advancedSearch={handleManualSearch}
          onRowClick={(event) =>
            showThisInf(event)
          }
        // onSelectRow={(selectedRows) => handleCheckedRow(selectedRows)}
        />
      </div>
      {adduser && (
        <PopupLoaderNew
          title={"Add User"}
          content={<AddUser onClose={togglePopup}
            setHasPrevilege={setHasPrevilege}
            setErrorMessage={setErrorMessage}
            groupInfo={props?.groupInfo ?? null}
            locUser={props?.locUsers ?? null}
            ref={addUserRef}
            setIsloading={setisLoading}
          />}
          onShow={setAdduser}
          onClose={togglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
      {adduserToGroup && (
        <PopupLoaderNew
          title={"Add User to a Group"}
          content={<AddToUsers
            onClose={togglegPopup}
            selectedUsers={groupUsers}
            setUpdateUsers={setUpdateUsers}
            setIsAddedUsers={setIsAddedUsers}
            sourceUsers={props.sourceUsers}
            ref={addToUserRef}
            setIsloading={setisLoading}
          />}
          onShow={setAdduserToGroup}
          onClose={togglegPopup}
          onSave={handleAddToUser}
          isloading={isLoading}
          flag={1}
        />
      )}
      {isdelete && (
        <PopupLoaderNew
          title={"Remove User"}
          content={
            <RemoveToUser
              setIsDeleteUser={setIsDeleteUser}
              onClose={dUtogglePopup}
              ref={addToUserRef}
              setIsloading={setisLoading}

            />
          }
          onShow={setIsDelete}
          onClose={dUtogglePopup}
          onSave={handleAddToUser}
          isloading={isLoading}
          flag={4}
        />
      )}
      {deleteuser && (
        <PopupLoaderNew
          title={"Remove User"}
          content={<DeleteUser
            extension={extension}
            user={selectedUser}
            agentsName={agentNameList}
            storageAgents={storageAgents}
            deleteReasons={deleteReasons}
            transferMessage={transferMessage}
            streamletAlertInfo={streamletAlertInfo}
            groupInfo={props?.groupInfo ?? null}
            locUser={props?.locUsers ?? null}
            onClose={dtogglePopup}
            ref={addToUserRef}
            setIsloading={setisLoading}
            assocCFData={assocCallFlows}
            assocLunaHops={assocLunaHops}
          />}
          onShow={setDeleteuser}
          onClose={dtogglePopup}
          onSave={handleAddToUser}
          isloading={isLoading}
          flag={assocCallFlows.length == 0 && assocLunaHops.length == 0 ? 4 : 10}
          hideClose={assocCallFlows.length == 0 && assocLunaHops.length == 0 ? false : true}
        />
      )}

      <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1' staticBackdrop closeOnEsc={false}>
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
              {/* <MDBBtn className='btn-close' color='none' onClick={importuserToggle}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {ExportUser && (
        <PopupLoader
          title={"Export User Template"}
          content={<ExportUsers />}
          onShow={setExportUser}
          onClose={ExportUserToggle}
        />
      )}

      {deleteFilter && (
        <PopupLoaderNew
          title={"Remove User"}
          content={<DeleteUserFilter
            filterKey={filterKey}
            groupInfo={props?.groupInfo ?? null}
            locUser={props?.locUsers ?? null}
            groupUInfo={props?.groupUInfo ?? null}
            onClose={deleteFilterToggle}
            ref={addUserRef}
            setIsloading={setisLoading}
          />}
          onShow={setdeleteFilter}
          onClose={deleteFilterToggle}
          onSave={handleAddToUser}
          isloading={isLoading}
          flag={4}
        />
      )}


      {hasPrevilege && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          delay={1000000}
          position={position} appendToBody
        >
          <i className="fas fa-times-circle me-3"></i>
          <span className="alert-msg">{errorMessage}</span>
        </MDBAlert>
      )}

      <div id="common-more-options-portal"></div>

      {showWarning && (
        <ImportProgressWarning
          warningToggle={warningToggle}
          setShowWarning={setShowWarning}
          onOk={warningToggle}
          message={warningMessage}
        />
      )}

      {showImpExpRedirect && (
        <ImpExpRedirectPopup
          onProceed={() => {
            setShowImpExpRedirect(false);
            setfirstRequest(true);
            importuserToggle();
          }}
          onCancel={() => setShowImpExpRedirect(false)}
        />
      )}

      <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
        {isDisabled ? "Do not have previlege to delete user" : "Remove"}
      </Tooltip>

      <Tooltip anchorSelect=".streamsLogin" place="top" className="exampleTooltip">
        {streamsProductName} Login
      </Tooltip>
    </>
  );
}


export async function getAssocCFDataByEntityIdNodeType(siteId, entityId, nodeType) {
  try {
    let apiResponse = await getAssociatedCFData(siteId, entityId, nodeType);
    let apiResBody = await apiResponse.json();
    return apiResBody;
  } catch (error) {
  }
  return [];
}